import React, { useState, useEffect, } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import { PageBar, SSPCommonButton, SSPCommonVideo } from '../../CommonComponents';
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import DeviceHubIcon from '@mui/icons-material/DeviceHub';

import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography, CircularProgress
} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import { functionURLService } from '../../Components/functionalurl';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components';
import { post } from "../../services";
import Cookies from "js-cookie";
import styles from './Styles';
const base = "https://";

const StyledDatePicker = styled(DatePicker)`
    width: 200px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
    color: #333;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    box-sizing: border-box;
`;
const Approve_Transfer = ({ id, token, roleid }) => {

    const getCurrentDate = () => {
        return new Date();
    };
    // const { id,token } = useParams();s
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [uploadername, setUploadername] = useState("");
    const [approvalstatus, setApprovalstatus] = useState("");
    // const [selectedOption, setSelectedOption] = useState("Last 7 days");
    const [selectedOption, setSelectedOption] = useState("Select Creation Date");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const currentDate = getCurrentDate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [rejectionReason, setRejectionReason] = useState("");
    const [viewReasonRow, setViewReasonRow] = useState(null);
    const [fromlocation, setFromLocation] = useState("");
    const [tolocation, setToLocation] = useState("");
    const [approvalStatusOptions, setApprovalStatusOptions] = useState([]);
    const [fromlocationOptions, setFromLocationOptions] = useState([]);
    const [tolocationOptions, setToLocationOptions] = useState([]);
    const [storesData, setStoresData] = useState();
    const [storesModalOpen, setStoresModalOpen] = useState(false);
    const [multiRejectModalOpen, setMultiRejectModalOpen] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);
    const [bulkApproveLoading, setBulkApproveLoading] = useState(false);
    const [loading, setLoading] = useState(null);
    const [disabledRows, setDisabledRows] = useState({});
    const [loadingRow, setLoadingRow] = useState(false);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [loadingApproveRow, setLoadingApproveRow] = useState(null);
    const [loadingRejectRow, setLoadingRejectRow] = useState(null);
    const [uploaderOptions, setUploaderOptions] = useState([]);
    const [isAllRowsDisabled, setIsAllRowsDisabled] = useState(false);

    const handleChangeFromLocation = (event) => {
        setFromLocation(event.target.value);
    };
    const handleChangeUploadername = (event) => {
        setUploadername(event.target.value);
    };

    const handleChangeToLocation = (event) => {
        setToLocation(event.target.value);
    };
    const handleChangeApprovalstatus = (event) => {
        setApprovalstatus(event.target.value);
    };
    const today = currentDate;
    useEffect(() => {
        const currentDate = new Date();
        const lastWeekDate = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        setStartDate(lastWeekDate);
        setEndDate(currentDate);
    }, []);

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
        const currentDate = new Date();
        const yesterdayDate = new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000);

        if (event.target.value === "Today") {
            setStartDate(currentDate);
            setEndDate(currentDate);
        } else if (event.target.value === "Yesterday") {
            setStartDate(yesterdayDate);
            setEndDate(yesterdayDate);
        } else if (event.target.value === "This Month") {
            setStartDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
            setEndDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0));
        } else if (event.target.value === "Last Month") {
            const lastMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const lastMonthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
            setStartDate(lastMonthStart);
            setEndDate(lastMonthEnd);
        } else if (event.target.value === "Last 7 days") {
            setStartDate(new Date(currentDate.getTime() - 6 * 24 * 60 * 60 * 1000));
            setEndDate(currentDate);
        } else if (event.target.value === "Last 30 days") {
            setStartDate(new Date(currentDate.getTime() - 29 * 24 * 60 * 60 * 1000));
            setEndDate(currentDate);
        } else if (event.target.value === "Custom") {
            setStartDate(null);
            setEndDate(null);
        }
    };

    const handleStartDateChange = (date) => {
        setStartDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0) : null);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59) : null);
    };

    const getMonthName = (date) => {
        const months = [
            "Jan",
            "Feb",
            "March",
            "April",
            "May",
            "June",
            "July",
            "Aug",
            "Sept",
            "Oct",
            "Nov",
            "Dec",
        ];
        return months[date.getMonth()];
    };
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = getMonthName(date);
        const day = ("0" + date.getDate()).slice(-2);
        return `${month},${day} ${year}`;
    };

    const [rows, setRows] = useState([]);
    const [originalRowsData, setOriginalRowsData] = useState([]);
    const [response, setResponse] = useState(null);
    const [uploaderId, setUploaderId] = useState(null);
    const rowFetch = async () => {
        // setmessage("Fetching Data");
        setLoadingRow(true)
        let response = await post(
            base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/get_approval_data",
            {},
            true,
            false
        );
        if (response?.body?.data?.length > 0) {
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setOriginalRowsData(rowsData);
            setRows(rowsData);
            setLoadingRow(false)
            const uniqueFromLocationOptions = Array.from(new Set(rowsData.map((row) => row.from_loc_name)));
            const uniqueToLocationOptions = Array.from(new Set(rowsData.map((row) => row.to_loc_name)));
            const uniqueApprovalStatusOptions = Array.from(new Set(rowsData.map((row) => row.approval_status)))
            const uniqueUplodernameOptions = Array.from(new Set(rowsData.map((row) => row.uploder_name)))
            const allUploaderIds = rowsData.map((row) => row.uploader_id);
            setUploaderId(allUploaderIds);

            setUploaderOptions(uniqueUplodernameOptions)
            setFromLocationOptions(uniqueFromLocationOptions);
            setToLocationOptions(uniqueToLocationOptions);
            setApprovalStatusOptions(uniqueApprovalStatusOptions);
        }
        else {
            setLoadingRow(false)
            setmessage("No Rows");
            setmodalOpener(true);
        }
        setResponse(response);
    };
    useEffect(() => {
        rowFetch();
    }, []);

    useEffect(() => {
        setStartDate(null)
        setEndDate(null)
    }, [])

    const handleFilterData = () => {

        const formattedStartDate = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()) : null;
        const formattedEndDate = endDate ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59) : null;
        const filteredData = originalRowsData.filter((row) => {
            const rowDateParts = row.create_date.split('-');
            const rowDate = new Date(
                parseInt(rowDateParts[2], 10),
                parseInt(rowDateParts[1], 10) - 1,
                parseInt(rowDateParts[0], 10)
            );
            const dateMatch = !startDate || (rowDate >= formattedStartDate && rowDate <= formattedEndDate);
            const fromlocationMatch = fromlocation === "" || row.from_loc_name === fromlocation;
            const tolocationMatch = tolocation === "" || row.to_loc_name === tolocation;
            const approvalstatusMatch = approvalstatus === "" || row.approval_status === approvalstatus;
            const uploaderNameMatch = uploadername === "" ||
                (row.uploder_name && row.uploder_name?.toLowerCase() === uploadername?.toLowerCase());
            return dateMatch && fromlocationMatch && tolocationMatch && approvalstatusMatch && uploaderNameMatch;

        });
        setRows(filteredData);
    };

    const handleMultiApprove = async (selectedRowIds) => {
        try {
            setBulkApproveLoading(true);
            const logIdsArray = selectedRowIds.map((rowId) => rows.find((row) => row.id === rowId).log_id);
            await handleApprove(logIdsArray);
        } catch (error) {
            console.error("Error approving rows:", error);
        } finally {
            setBulkApproveLoading(false);
        }
    };
    const handleSelectAll = () => {
        const selectableRowIds = rows
            .filter((row) => row.approval_status === 'Pending')
            .map((row) => row.id);

        setSelectedRowIds(selectableRowIds);
    };

    const handleApprove = async (logIdsArray) => {

        if (logIdsArray.length === 0) {
            setmessage("No rows selected. Please select at least one row to approve.");
            setmodalOpener(true);
            return;
        }
        try {

            setLoading(true);
            setLoadingApproveRow(logIdsArray);
            setDisabledRows((prevDisabledRows) => {
                const newDisabledRows = { ...prevDisabledRows };
                logIdsArray.forEach((logId) => {
                    newDisabledRows[logId] = true;
                });
                return newDisabledRows;
            });

            const approvalPayload = {
                "to_req_ids": Array.isArray(logIdsArray) ? logIdsArray : [logIdsArray],
                "action_type": 'Approve',
                "reject_reason": ""
            }

            const approvalResponse = await post(
                base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/to_approval",
                approvalPayload,
                true,
                false
            );
            if (approvalResponse.status === "success") {
                const updatedRows = rows.map((row) =>
                    logIdsArray.includes(row.log_id)
                        ? { ...row, approval_status: "Approved" }
                        : row
                );
                if (approvalResponse.status === "error") {
                    setmessage(approvalResponse?.body?.message);
                    setmodalOpener(true);
                }
                setRows(updatedRows);
                setLoading(false);
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            }
            else {
                console.error("Error during approval:", approvalResponse.message);
                setmessage(approvalResponse.message);
                setmodalOpener(true);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error in approval:", error.message);
            setmessage(error.message);
            setmodalOpener(true);
            setLoading(false);
        } finally {
            setLoading(false);
            setLoadingApproveRow(null);
            setDisabledRows((prevDisabledRows) => {
                const newDisabledRows = { ...prevDisabledRows };
                logIdsArray.forEach((logId) => {
                    delete newDisabledRows[logId];
                });
                return newDisabledRows;
            });

        }
    };

    const handleReject = (id) => {
        setSelectedRow(id);
    };
    const handleMultiReject = () => {
        if (selectedRowIds.length === 0) {
            setmessage("No rows selected. Please select at least one row to reject.");
            setmodalOpener(true);
            return;
        }
        setRejectionReason("");
        setRejectLoading(true);
        setMultiRejectModalOpen(true); // Open the rejection reason dialog
    };


    const handleRejectSubmission = async (logId) => {
        if (!rejectionReason) {
            setmessage("Please provide a rejection reason");
            setmodalOpener(true);
            return;
        }
        try {
            setLoading(true);
            setLoadingRejectRow([logId]);

            setDisabledRows((prevDisabledRows) => ({
                ...prevDisabledRows,
                [logId]: true,
            }));
            const logIdsArray = selectedRowIds.map((selectedRowId) => {
                const selectedRowData = rows.find((row) => row.id === selectedRowId);
                return selectedRowData.log_id;
            });

            const approvalPayload = {
                "to_req_ids": logIdsArray || [selectedRow],
                "action_type": 'Reject',
                "reject_reason": rejectionReason
            }

            const approvalResponse = await post(
                base + "nhiva43pyu4b2dlutiu75htvka0nwvcw.lambda-url.ap-south-1.on.aws/to_approval",
                approvalPayload,
                true,
                false
            );
            if (approvalResponse.status === "success") {
                const updatedRows = rows.map((row) =>
                    logIdsArray.includes(row.log_id)
                        ? {
                            ...row,
                            approval_status: "Rejected",
                            reason: rejectionReason,
                        }
                        : row
                );
                setRows(updatedRows);
                setSelectedRow(null)
                setRejectionReason("");
                setmessage("Selected POs rejected successfully!");
                setmodalOpener(true);
                setMultiRejectModalOpen(false); // Close the dialog
                setLoading(false);
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } else if (approvalResponse.status === "error") {

                setmessage(approvalResponse?.body?.message);
                setSelectedRow(null)
                setmodalOpener(true);
                setLoading(false);
            }
            else {
                setSelectedRow(null)
                console.error("Error:", approvalResponse.message);
                setmessage(approvalResponse.message);
                setmodalOpener(true);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error:", error);
            setmessage(error.message);
            setmodalOpener(true);
            setLoading(false);
        } finally {
            setLoading(false);
            setRejectLoading(false);
            setSelectedRowIds([]); // Clear selected rows
            setLoadingRejectRow(null);
            setDisabledRows((prevDisabledRows) => {
                const newDisabledRows = { ...prevDisabledRows };
                delete newDisabledRows[logId];
                return newDisabledRows;
            });
        }
    };

    const handleViewReason = (row) => {
        setViewReasonRow(row);
    };

    const handleViewDataClick = (rowData) => {
        console.log(rowData.asset_details);
        setStoresData(rowData.asset_details);
        setStoresModalOpen(true);
    };
    const HoverCell = ({ value }) => {
        return (
            <Tooltip
                title={
                    <span style={{ fontSize: "16px" }}>{value}</span>
                }
            >
                <div
                    style={{
                        whiteSpace: "none",
                        textAlign: "start",
                        maxWidth: "100%",
                    }}
                >{value}</div>
            </Tooltip>
        );
    };

    const clearFilter = () => {
        window.location.reload();
        setFromLocation("");
        setUploadername("");
        setToLocation("");
        setApprovalstatus("");
        setStartDate(null)
        setEndDate(null)
    }

    const columns = [

        { field: 'log_id', headerName: 'Request Id', flex: 0.8 },
        {
            field: "from_loc_name",
            headerName: "From Location",
            flex: 1.2,
            wordBreak: "break-word",
            renderCell: (params) => <HoverCell value={params.value} />,
        },
        {
            field: 'to_loc_name', headerName: 'To Location', flex: 1.3,
            renderCell: (params) => {
                return <HoverCell value={params.value} />;
            },
        },
        { field: 'create_date', headerName: 'Create Date', flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'asset_count', headerName: 'Asset Count', flex: 0.7, headerAlign: 'center', align: 'center' },
        {
            field: 'asset_details',
            headerName: 'Asset Details',
            flex: 1,
            renderCell: (params) => (
                <Button
                    size="small"
                    onClick={() => handleViewDataClick(params.row)}
                >
                    View Assets
                </Button>
            ),
        },
        { field: 'to_value', headerName: 'TO value', flex: 1, headerAlign: 'center', align: 'center' },
        {
            field: 'uploder_name', headerName: 'Uploader Name', flex: 1,
            renderCell: (params) => {
                return <HoverCell value={params.value} />;
            },
        },
        {
            field: 'approval_status',
            headerName: 'Action',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                    }}

                >
                    {params.row.approval_status
                        ? (
                            <div>
                                {params.row.approval_status === "Pending" ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                        <Button
                                            size="small"
                                            style={{
                                                backgroundColor: disabledRows[params.row.log_id] ? '#ccc' : '#6757fe',
                                                color: 'white',
                                                width: '90px',
                                                fontSize: '0.75rem',
                                                padding: '2px 6px',
                                            }}
                                            onClick={() => {
                                                handleApprove([params.row.log_id])
                                            }}
                                            disabled={disabledRows[params.row.log_id] || loadingApproveRow?.includes(params.row.log_id)}
                                        >
                                            {loadingApproveRow?.includes(params.row.log_id) ? "Approving..." : "Approve"}
                                        </Button>
                                        <Button
                                            size="small"
                                            style={{
                                                backgroundColor: disabledRows[params.row.log_id] ? '#ccc' : '#e81500',
                                                color: 'white',
                                                width: '90px',
                                                fontSize: '0.75rem',
                                                padding: '2px 6px',
                                            }}
                                            onClick={() => handleReject(params.row.log_id)}
                                            disabled={disabledRows[params.row.log_id] || loadingRejectRow?.includes(params.row.log_id)}
                                        >
                                            {loadingRejectRow?.includes(params.row.log_id) ? "Rejecting..." : "Reject"}
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        {params.row.approval_status === 'Approved' ? (
                                            <div style={{ color: 'green', fontWeight: 'bold' }}>TO Created</div>
                                        ) : params.row.approval_status === 'Rejected' ? (
                                            <div style={{ height: '90%', justifyContent: 'center', alignItems: 'center', marginTop: 2 }}>
                                                <Typography component="div" style={{ color: 'red', fontWeight: 'bold', marginTop: 5, fontSize: 14 }}>
                                                    TO Rejected
                                                    <div>
                                                        <span
                                                            style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                                                            onClick={() => handleViewReason(params.row)}
                                                        >
                                                            View Reason
                                                        </span>
                                                    </div>
                                                </Typography>
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <div style={{ marginBottom: '5px' }}>
                                    <Button
                                        size="small"
                                        style={{ backgroundColor: '#6757fe', color: 'white', width: '100px' }}
                                        onClick={() => handleApprove([params.row.log_id])}
                                        disabled={loadingApproveRow?.includes(params.row.log_id) || loadingRejectRow?.includes(params.row.log_id)}
                                    >
                                        {loadingApproveRow?.includes(params.row.log_id) ? "Approving..." : "Approve"}
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        size="small"
                                        style={{ backgroundColor: '#e81500', color: 'white', width: '100px' }}
                                        onClick={() => handleReject(params.row.log_id)}
                                        disabled={loadingRejectRow?.includes(params.row.log_id) || loadingApproveRow?.includes(params.row.log_id)}
                                    >
                                        {loadingRejectRow?.includes(params.row.log_id) ? "Rejecting..." : "Reject"}
                                    </Button>
                                </div>
                            </div>
                        )}
                </div>
            ),
        }
    ];
    const StoresDataTable = ({ data }) => {
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>Asset ID </TableCell>
                        <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>Asset Description</TableCell>
                        <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>Value</TableCell>
                        <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>Current Assignee</TableCell>
                        <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>New Assignee</TableCell>
                        {/* Add other table headers as needed */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                                {item.is_split_asset ? (
                                    <Tooltip
                                        title="This asset is being split into multiple assets"
                                        arrow
                                        placement="top"
                                        PopperProps={{
                                            sx: {
                                                zIndex: 2000,
                                            }
                                        }}
                                    >
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'help' }}>
                                            {/* Hidden spacer to keep the Asset ID centered */}
                                            <Box sx={{ width: 28 }} />
                                            {item.asset_id}
                                            <DeviceHubIcon sx={{ color: 'orange', ml: 1, fontSize: '20px' }} />
                                        </Box>
                                    </Tooltip>
                                ) : (
                                    item.asset_id
                                )}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{item.asset_description}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{item.asset_value}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{item.current_assignee}</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>{item.new_assignee}</TableCell>
                            {/* Add other table cells as needed */}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    };
    // Checking if all rows are disabled
    useEffect(() => {
        const allDisabled = rows?.every((row) => row?.approval_status !== "Pending");
        setIsAllRowsDisabled(allDisabled);
    }, [rows]);

    return (
        <>
            <Box
                sx={{
                    backgroundColor: "#EEF2F7",
                }}>
                <PageBar text="Asset Management: Approve Transfer Requests" vendorId={id} />
                <Card
                    sx={{
                        backgroundColor: "#EEF2F7",
                        padding: "1.3rem",

                    }}
                >
                    {/* <CardHeader
                        p={2}
                        sx={{
                            backgroundColor: "#F8F8F9",
                            fontWeight: "700",
                            borderTopRightRadius: "5px",
                            borderTopLeftRadius: "5px",
                        }}
                        title={" Filters"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                    /> */}
                    <CardHeader
                        p={2}
                        sx={{
                            backgroundColor: "#F8F8F9",
                            fontWeight: "700",
                            borderTopRightRadius: "5px",
                            borderTopLeftRadius: "5px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                        title={
                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Typography
                                    sx={{
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        lineHeight: "16px",
                                        color: "#0160F1",
                                    }}
                                >
                                    Filters
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "16px",
                                        lineHeight: "16px",
                                        color: "#0160F1",
                                        opacity: fromlocation === '' && tolocation === '' && approvalstatus === '' && uploadername === '' && selectedOption === 'Select Creation Date' ? 0.5 : 1
                                    }}
                                    onClick={() => {
                                        if (!(fromlocation === '' && tolocation === '' && approvalstatus === '' && uploadername === '' && selectedOption === 'Select Creation Date')) {
                                            clearFilter();
                                        }
                                    }}
                                >
                                    CLEAR FILTER
                                </Typography>
                            </Box>
                        }
                    />
                    <Divider />

                    <CardContent
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderBottomRightRadius: "5px",
                            borderBottomLeftRadius: "5px",
                            fontSize: 15,
                            marginBottom: -5
                        }}
                    >
                        <Grid container Spacing={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <Typography sx={{ fontSize: 15 }}>From Location :</Typography>
                                <FormControl sx={{ maxWidth: 200, minWidth: 200, marginTop: 1, marginBottom: 1 }}>
                                    <Select
                                        displayEmpty
                                        size='small'
                                        sx={{ fontSize: 15 }}
                                        value={fromlocation}
                                        label="Select From Location"
                                        onChange={handleChangeFromLocation}
                                    >
                                        <MenuItem value="">
                                            <em sx={{ fontSize: 15 }}>Select From Location</em>
                                        </MenuItem>
                                        {fromlocationOptions.map((option) => (
                                            <MenuItem key={option} value={option} sx={{ fontSize: 15 }}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <Typography sx={{ fontSize: 15 }}>To Location :</Typography>
                                <FormControl sx={{ maxWidth: 200, minWidth: 200, marginTop: 1, marginBottom: 1 }}>
                                    <Select
                                        displayEmpty
                                        size='small'
                                        sx={{ fontSize: 15 }}
                                        value={tolocation}
                                        label="Select To Location"
                                        onChange={handleChangeToLocation}
                                    >
                                        <MenuItem value="">
                                            <em sx={{ fontSize: 15 }}>Select To Location</em>
                                        </MenuItem>
                                        {tolocationOptions.map((option) => (
                                            <MenuItem key={option} value={option} sx={{ fontSize: 15 }}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <Typography sx={{ fontSize: 15 }}>Creation Date :</Typography>
                                <div>
                                    <Select
                                        size='small'
                                        value={selectedOption}
                                        onChange={handleOptionChange}
                                        wordWrap='break-word'
                                        renderValue={(selected) => {
                                            switch (selected) {
                                                case 'This Month':
                                                    return `${getMonthName(today)} 1-${new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()}`;
                                                case 'Last Month':
                                                    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
                                                case 'Last 7 days':
                                                    return `${formatDate(new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000))} - ${formatDate(today)}`;
                                                case 'Last 30 days':
                                                    return `${formatDate(new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000))} - ${formatDate(today)}`;
                                                case 'Yesterday':
                                                    return formatDate(new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000));
                                                case 'Today':
                                                    return formatDate(new Date(today.getTime()));
                                                default:
                                                    return selected;
                                            }
                                        }}
                                        sx={{ maxWidth: 200, minWidth: 200, fontSize: 15, marginTop: 1, marginBottom: 1, whiteSpace: 'normal', wordWrap: 'break-word', overflow: 'hidden' }}
                                    >
                                        <MenuItem value="Today" sx={{ fontSize: 15 }}>Today</MenuItem>
                                        <MenuItem value="Yesterday" sx={{ fontSize: 15 }}>Yesterday</MenuItem>
                                        <MenuItem value="This Month" sx={{ fontSize: 15 }}>This Month</MenuItem>
                                        <MenuItem value="Last Month" sx={{ fontSize: 15 }}>Last Month</MenuItem>
                                        <MenuItem value="Last 7 days" sx={{ fontSize: 15 }}>Last 7 days</MenuItem>
                                        <MenuItem value="Last 30 days" sx={{ fontSize: 15 }}>Last 30 days</MenuItem>
                                        <MenuItem value="Custom" sx={{ fontSize: 15 }}>Custom</MenuItem>
                                    </Select>
                                    <Box >
                                        {selectedOption === "Custom" && (
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item >
                                                    <Typography sx={{ fontSize: 15 }}>Start Date:</Typography>
                                                    {/* <DatePicker selected={startDate} onChange={handleStartDateChange} maxDate={new Date()}/> */}
                                                    <StyledDatePicker
                                                        selected={startDate}
                                                        onChange={handleStartDateChange}
                                                        maxDate={new Date()}
                                                    />
                                                </Grid>
                                                <Grid item  >
                                                    <Typography sx={{ fontSize: 15 }}>End Date:</Typography>
                                                    {/* <DatePicker selected={endDate} onChange={handleEndDateChange}  minDate={startDate} maxDate={new Date()} /> */}
                                                    <StyledDatePicker
                                                        selected={endDate}
                                                        onChange={handleEndDateChange}
                                                        minDate={startDate}
                                                        maxDate={new Date()}

                                                    />
                                                </Grid>
                                            </Grid>
                                        )}

                                    </Box>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <Typography sx={{ fontSize: 15 }}>Approval Status :</Typography>
                                <FormControl sx={{ maxWidth: 200, minWidth: 200, marginTop: 1, marginBottom: 1 }}>
                                    <Select
                                        displayEmpty
                                        size='small'
                                        sx={{ fontSize: 15 }}
                                        value={approvalstatus}
                                        onChange={handleChangeApprovalstatus}
                                    >
                                        <MenuItem value="">
                                            <em sx={{ fontSize: 15 }}>Approval Status</em>
                                        </MenuItem>
                                        {approvalStatusOptions.map((option) => (
                                            <MenuItem key={option} value={option} sx={{ fontSize: 15 }}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                <Typography sx={{ fontSize: 15 }}>Select Uploader Name</Typography>
                                <FormControl sx={{ maxWidth: 200, minWidth: 200, marginTop: 1, marginBottom: 1 }}>
                                    <Select
                                        displayEmpty
                                        size="small"
                                        sx={{ fontSize: 15 }}
                                        value={uploadername}
                                        onChange={handleChangeUploadername}
                                        renderValue={(selected) => {
                                            return selected ? selected : <em style={{ color: "black" }}>Select Uploader Name</em>;
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>Select Uploader Name</em>
                                        </MenuItem>
                                        {uploaderOptions?.map((option) => (
                                            <MenuItem key={option} value={option} sx={{ fontSize: 15 }}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid xl={1} lg={1.5} md={2} sm={12} xs={12} item sx={{
                                marginTop: 1,
                                marginBottom: 1,
                                justifyContent: "center",
                                alignItems: 'center',
                                padding: 2
                            }}>
                                <SSPCommonButton
                                    btnText={"Filter Data"}
                                    btnFunction={handleFilterData}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card
                    sx={{
                        backgroundColor: "#EEF2F7",
                        padding: "1.3rem",
                    }}
                >
                    <CardHeader
                        p={2}
                        sx={{
                            backgroundColor: "#F8F8F9",
                            fontWeight: "700",
                            borderTopRightRadius: "5px",
                            borderTopLeftRadius: "5px",
                        }}
                        title={"Transfer Requests"}
                        titleTypographyProps={{
                            sx: {
                                fontSize: "16px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#0160F1",
                            },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    <CardContent
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderBottomRightRadius: "5px",
                            borderBottomLeftRadius: "5px",
                        }}

                    >
                        {loadingRow || loading && (
                            <div style={styles.loaderOverlay}>
                                <CircularProgress />
                            </div>
                        )}
                        <Box
                            sx={{
                                display: { lg: "flex" },
                            }}
                        >
                        </Box>
                        <div>
                            <div style={{ height: 700, width: '100%' }}>
                                <DataGrid
                                    // disableColumnMenu={true}
                                    rowHeight={80}
                                    showCellRightBorder={true}
                                    sx={{
                                        ".MuiDataGrid-columnHeaderTitle": {
                                            fontWeight: "bold !important",
                                        },
                                        overflowX: "scroll",
                                    }}
                                    rows={rows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    checkboxSelection
                                    isRowSelectable={(params) =>
                                        params.row.approval_status === 'Pending'
                                    }
                                    rowSelectionModel={selectedRowIds}
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setSelectedRowIds(newRowSelectionModel);
                                    }}
                                    headerClassName="header-center"
                                    rowsPerPageOptions={[10]}
                                    pageSize={10}
                                    getRowId={(row) => row.id}
                                    components={{
                                        Toolbar: GridToolbar,
                                    }}
                                    componentsProps={{
                                        Toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', width: '100%' }}>
                                <Button
                                    onClick={() => handleSelectAll()}
                                    disabled={isAllRowsDisabled}
                                    style={{
                                        backgroundColor: "rgb(81,171,59)",
                                        color: "white",
                                        marginRight: "10px",
                                        opacity: isAllRowsDisabled ? 0.5 : 1,
                                        cursor: isAllRowsDisabled ? "not-allowed" : "pointer",
                                    }}
                                >
                                    Select All
                                </Button>

                                <Button onClick={() => handleMultiApprove(selectedRowIds)}
                                    disabled={loading || bulkApproveLoading || isAllRowsDisabled}
                                    style={{
                                        backgroundColor: '#6757fe', color: 'white', marginRight: '10px',
                                        opacity: isAllRowsDisabled ? 0.5 : 1,
                                    }}>
                                    {bulkApproveLoading ? 'Approving ...' : 'Approve'}
                                </Button>
                                <Button onClick={() => handleMultiReject(selectedRowIds)}
                                    disabled={loading || rejectLoading || isAllRowsDisabled}

                                    style={{
                                        backgroundColor: '#e81500', color: 'white',
                                        opacity: isAllRowsDisabled ? 0.5 : 1,
                                    }}>
                                    {rejectLoading ? 'Rejecting ...' : 'Reject'}
                                </Button>
                            </div>
                        </div>

                        {storesModalOpen && (
                            <SSPCommonModal
                                open={storesModalOpen}
                                handleOpenClose={setStoresModalOpen}
                                message={<StoresDataTable data={storesData} />}
                            />
                        )}
                        <div>
                            {selectedRow !== null && (
                                <Dialog open={selectedRow !== null} onClose={() => setSelectedRow(null)} fullWidth>
                                    <DialogTitle fontWeight={"bold"} fontSize={18}>Reject TO : Please add rejection reason</DialogTitle>
                                    <DialogContent>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                                            <Typography style={{ marginRight: '8px' }}>Rejection Reason :<b style={{ color: "red" }}> * </b></Typography>
                                            <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                label="Rejection Reason"
                                                value={rejectionReason}
                                                onChange={(e) => setRejectionReason(e.target.value)}
                                                style={{ width: '70%' }}
                                            />
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => setSelectedRow(null)}>Cancel</Button>
                                        <Button onClick={() => handleRejectSubmission(selectedRowIds)} disabled={loading} variant="contained" style={{ backgroundColor: '#6757fe' }}>
                                            {loading ? 'Rejecting PO...' : 'Reject TO'}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            )}
                        </div>


                        <div>
                            {selectedRowIds.length > 0 && (
                                <Dialog open={multiRejectModalOpen} onClose={() => { setMultiRejectModalOpen(false); setLoading(false); setRejectLoading(false); }} fullWidth>
                                    <DialogTitle fontWeight={"bold"} fontSize={18}>Reject TO: Please add rejection reason</DialogTitle>
                                    <DialogContent>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                                            <Typography style={{ marginRight: '8px' }}>Rejection Reason<b style={{ color: "red" }}> * </b></Typography>
                                            <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                label="Rejection Reason"
                                                value={rejectionReason}
                                                onChange={(e) => setRejectionReason(e.target.value)}
                                                style={{ width: '70%' }}
                                            />
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => { setMultiRejectModalOpen(false); setRejectLoading(false); setLoading(false) }}>Cancel</Button>
                                        <Button onClick={() => handleRejectSubmission(selectedRowIds)} disabled={loading} variant="contained" style={{ backgroundColor: '#6757fe' }}>
                                            {loading ? 'Rejecting TOs...' : 'Reject TO'}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            )}
                        </div>

                        {viewReasonRow && (
                            <Dialog open={viewReasonRow !== null} onClose={() => setViewReasonRow(null)}
                            >
                                <DialogTitle sx={{ fontWeight: 'bold', fontSize: 18 }}>{`Log id - ${viewReasonRow.log_id} : Rejection Details`}</DialogTitle>
                                <Divider />
                                <DialogContent>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                                        <Typography sx={{ marginRight: '8px' }}>Rejection Reason :</Typography>
                                        <Box
                                            sx={{
                                                border: '1px solid #ccc',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                maxWidth: 300,
                                                minWidth: 200,
                                                textAlign: 'center'
                                            }}
                                        >
                                            {viewReasonRow.to_rejection_reason}
                                        </Box>
                                    </div>
                                </DialogContent>
                            </Dialog>
                        )}

                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>
                {/* Video  */}
                <SSPCommonVideo
                    headerText={"Demo Video"}
                    videoUrl={"https://www.youtube.com/embed/3oIyi21Nw8A"}
                />

            </Box>
        </>
    );
};

export default Approve_Transfer